import { Controller, FieldError, get, useFormContext } from 'react-hook-form';

import {
  Box,
  FormControlLabel,
  FormHelperText,
  Switch,
  SwitchProps,
  styled,
} from '@mui/material';

import { FormElementProps } from '@/components';

export interface FormSwitchFieldProps
  extends Omit<SwitchProps, 'name' | 'onChange'>,
    FormElementProps {
  label?: string;
  handleChange?: (name: string, value: boolean) => void;
}

const Root = styled(Box)(({ theme }) => ({
  flex: 1,
  minWidth: '100%',
  maxWidth: '100%',
  marginBottom: 8,
  '& .MuiInputBase-root': {
    width: '100%',
  },
  '& .MuiFormControlLabel-label': {
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    color: theme.palette.text.primary,
    marginTop: '1.5px',
  },
}));

export const FormSwitchField = (props: FormSwitchFieldProps) => {
  const { label, name, rules, disabled, handleChange } = props;
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const error = get(errors, name) as FieldError;

  return (
    <Root>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <FormControlLabel
            control={
              <Switch
                className="checkbox"
                color="error"
                disabled={disabled}
                {...field}
                checked={!!field.value}
                onChange={(e) => {
                  field.onChange(e);
                  if (handleChange) {
                    handleChange(name, e.target.checked);
                  }
                }}
              />
            }
            label={label}
          />
        )}
      />
      <FormHelperText error>{error?.message}</FormHelperText>
    </Root>
  );
};
